import { Button, Container, Icon, IconButton, RubricTable, Stack, Text, styled } from 'shell/components';

const Mobile = ({ rubric, onClickBack, onClickEdit, onClickDownloadCSV, onClickDelete }) => {
    return (
        <Container device={'mobile'}>
            <RootStack spacing={5}>
                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Button startIcon={<Icon kind={'arrowLeft'} />} variant={'borderless'} onClick={onClickBack}>
                        Back
                    </Button>
                    <Stack direction={'row'} spacing={4}>
                        <IconButton
                            aria-label={'edit'}
                            kind={'edit'}
                            size={'medium'}
                            tooltip={{ component: 'Delete' }}
                            variant={'square'}
                            onClick={() => onClickEdit(rubric)}
                        />
                        <IconButton
                            aria-label={'download'}
                            kind={'download'}
                            size={'medium'}
                            tooltip={{ component: 'Download CSV' }}
                            variant={'square'}
                            onClick={() => onClickDownloadCSV(rubric)}
                        />
                        <IconButton
                            aria-label={'destructive'}
                            kind={'delete'}
                            size={'medium'}
                            tooltip={{ component: 'Edit' }}
                            variant={'square'}
                            onClick={() => onClickDelete(rubric)}
                        />
                    </Stack>
                </Stack>
                <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                    {rubric.rubric.title}
                </Text>
                <RubricTable isExpanded type={'view'} data={rubric.rubric.criteria} />
            </RootStack>
        </Container>
    );
};

const RootStack = styled(Stack)(({ theme }) => {
    return {
        width: '100%',
        paddingBottom: theme.spacing(5),
    };
});

export default Mobile;
